window.addEventListener('message', function (event) {
  if (event.data?.type === 'form_submitted' && event.data?.payload) {
    const formId = event.data.payload.form_id;
    const formKey = `form_${formId}`;
    const formName = event.target.hulkFormBuilder?.form_data?.[formKey]?.form_name || 'Unknown Form';

    const gtmData = {
      event: 'contact_vendor_form',
      form_id: formId,
      form_name: formName,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtmData);
  }

  if (event.data.event === 'calendly.event_scheduled' && event.data?.payload) {
    const productName = event.target.meta?.product?.variants?.[0]?.name || 'Unknown Product';

    const gtmData = {
      event: 'book_time_form',
      meeting_uri: event.data.payload.event.uri,
      product_name: productName,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtmData);
  }
});
